import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../lib/axios';
import ReportView from '../components/ReportView';

export default function ShareReport() {
  const { token } = useParams();
  const [state, setState] = useState({ loading: true });

  useEffect(() => {
    api.get(`/share/agent-report/${token}`, { skipProject: true })
      .then(({ data }) => setState({ loading: false, data }))
      .catch(() => setState({ loading: false, error: true }));
  }, [token]);

  if (state.loading) {
    return <div className="min-h-screen flex items-center justify-center text-[14px] text-gray-500">Lädt…</div>;
  }
  if (state.error || ! state.data?.report) {
    return (
      <div className="min-h-screen flex items-center justify-center text-center px-4">
        <div>
          <div className="text-[16px] font-semibold text-[#0D3B50] mb-1">Report nicht verfügbar</div>
          <div className="text-[13px] text-gray-500">Der Link ist ungültig oder es wurde noch kein Report erstellt.</div>
        </div>
      </div>
    );
  }

  const { project, logo, report } = state.data;
  const accent = project?.color || '#0C9488';

  return (
    <div className="min-h-screen bg-[#EDECEA] py-8 px-4">
      <style>{`@media print { .no-print { display:none !important; } body { background:#fff; } }`}</style>
      <div className="max-w-4xl mx-auto">
        <div className="flex justify-end mb-3 no-print">
          <a href={`/api/share/agent-report/${token}/pdf`} target="_blank" rel="noreferrer" className="text-[13px] px-3.5 py-2 bg-[#0D3B50] text-white rounded-lg hover:opacity-90">
            PDF herunterladen
          </a>
        </div>
        <ReportView report={report} project={project} accent={accent} logo={logo} />
      </div>
    </div>
  );
}
